<template>
  <div class="ctn" :style="{width:ctnSize+'px',height:ctnSize+'px','border-radius':radius+'px','background-color':backColor}" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <svg-icon :svgname="svgname" :size="iconSize" :fill="hover?'white':'var(--ek-text-color2)'"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
export default {
  name: 'IconView',
  components:{
    SvgIcon
  },
  props: {
    svgname:String,
    iconSize:Number,
    backColor:{
        type:String,
        default:"transparent"
    },
    ctnSize:{
        type:Number,
        default:25
    },
    radius:{
        type:Number,
        default:5
    }
  },
  data(){
    return {
        hover:false
    }
  },
  methods:{
    handleMouseEnter(){
      this.hover = true;
    },
    handleMouseLeave(){
      this.hover = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ctn{
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.ctn:hover{
    background-color: var(--ek-color-primary)!important;
}
</style>
